define(['angular'], function(angular) {


    function EditionProvider() {
        let bdcUrl;

        /**
         * @param {String} url
         */
        this.setBDCUrl = function setBDCUrl(url) {
            bdcUrl = url;
        };

        this.$get = [
            '$http',
            function($http) {
                let self = {};

                self.getBdcUrl = function() {
                    return bdcUrl;
                };

                /**
                 * CGenerate Pdf
                 * @param  {int} id
                 * @param {string} template
                 * @return {Promise}
                 */
                self.getPdf = function getPdf(id, template) {
                    return $http.post(bdcUrl + 'edition/template/' + template, id).then(function(res) {
                        return res.data;
                    });
                };

                self.getAllPartners = function(env) {
                    return $http.get(bdcUrl + 'edition/partners/' + env).then(function(res) {
                        return res.data;
                    });
                };

                self.getDocumentsByPartner = function(id) {
                    return $http.post(bdcUrl + 'edition/documents', id).then(res => {
                        return res.data;
                    });
                };

                self.printBusiness = function(data) {
                    return $http.post(bdcUrl + 'edition/print/business', data).then(res => {
                        return res.data;
                    });
                }

                self.mergeDocumentWithCgv = function (doc){
                    return $http
                        .post(bdcUrl + 'edition/merge/cgv', {base64: doc} ).then( res => {
                            // console.log(res.data);
                            return res.data;
                        });
                }

                return self;
            }
        ];
    }

    angular.module('app.kya.edition.editionProvider', []).provider('edition', EditionProvider);
});
